import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { ModusButtonModule, ModusIconModule, ModusTooltipModule } from '@trimble-gcs/modus';
import { ScandataModel } from '../../../scandata/scandata.models';
import { MultiSelectedComponent } from './multi-selected/multi-selected.component';
import { recycleBinOptionsPanelTranslations } from './recycle-bin-options-panel.translations';
import { SingleSelectedComponent } from './single-selected/single-selected.component';

enum View {
  SingleSelected = 'SingleSelected',
  MultiSelected = 'MultiSelected',
}

@Component({
  selector: 'sd-recycle-bin-options-panel',
  standalone: true,
  imports: [
    CommonModule,
    SingleSelectedComponent,
    MultiSelectedComponent,
    ModusButtonModule,
    ModusIconModule,
    ModusTooltipModule,
  ],
  templateUrl: './recycle-bin-options-panel.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RecycleBinOptionsPanelComponent {
  readonly selectedScans = input.required<ScandataModel[]>();
  readonly previewVisible = input(true);
  readonly disabled = input(false);

  readonly previewVisibleChanged = output<boolean>();
  readonly closeClicked = output();
  readonly deleteClicked = output();
  readonly restoreClicked = output();

  readonly translations = recycleBinOptionsPanelTranslations();
  readonly view = View;
  readonly singleSelectedScan = computed(() => this.selectedScans()[0]);
  readonly currentView = computed(() =>
    this.selectedScans().length === 1 ? View.SingleSelected : View.MultiSelected,
  );
}
